module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('multipane', {
    staticClass: "custom-resizer",
    attrs: {
      "layout": "vertical"
    }
  }, [(_vm.layout === 'split' || _vm.layout === 'left') ? [_c('div', {
    staticClass: "pane",
    staticStyle: {
      "width": "100vw"
    }
  }, [_c('router-view', {
    attrs: {
      "routeName": _vm.routeName
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('multipane-resizer'), _vm._v(" "), (_vm.layout === 'split' || _vm.layout === 'right') ? [_c('div', {
    staticClass: "pane",
    staticStyle: {
      "width": "100vw"
    }
  }, [(_vm.params.id) ? [_c('router-view', {
    attrs: {
      "routeName": _vm.routeName,
      "name": "a"
    }
  })] : [_c('div', {
    staticClass: "index-box"
  })]], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47f24ff2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Tutors/Tutors2.vue
// module id = 1367
// module chunks = 0